import { ICharacter } from "@next-platform/client-common-core";

import { IRecommItems } from "@/hooks/types";

export const modifyHitsToAddRecommId = (hits: ICharacter[] = [], result: IRecommItems = {} as IRecommItems): ICharacter[] => {
  const updatedHits =
    hits?.map((character: ICharacter) => {
      const ifRecommendedSearchClientChar = result?.recomms?.find((recommendedChar) => character?.id === recommendedChar?.id);

      if (ifRecommendedSearchClientChar) {
        character["recommId"] = result?.recommId;
      }

      return character;
    }) || []; // Ensure updatedHits is an array.

  // Append remaining characters from recommendations to updatedHits
  const remainingCharacters = result?.recomms?.filter((recommendedChar) => !updatedHits?.some((hit) => hit?.id === recommendedChar?.id));

  const recommendationList: ICharacter[] = [];
  remainingCharacters?.forEach((recommendedChar) => {
    const characterData = {
      ...recommendedChar.values,
      recommId: result?.recommId,
      id: recommendedChar?.id,
    } as ICharacter;
    recommendationList.push(characterData);
  });

  updatedHits.push(...recommendationList); // Ensure updatedHits is always an array.

  return updatedHits;
};
